import {createSlice} from '@reduxjs/toolkit';
import _ from 'lodash';

const INITIAL_STATE = {
  autoApproveReports: false,
  currentPeriod: '',
  comparePeriod: '',
  hasDifference: false,
  fluxAnalysisActive: false,
  fluxAnalysisLoading: false,
  fluxChangesLoading: false,
};

export const reportsSlice = createSlice({
  name: 'periods',
  initialState: INITIAL_STATE,
  reducers: {
    setAutoApproveReports: (state, action) => {
      state.autoApproveReports = action.payload.autoApproveReports;
    },
    setCurrentPeriod: (state, action) => {
      state.currentPeriod = action.payload.currentPeriod;
    },
    setComparePeriod: (state, action) => {
      state.comparePeriod = _.get(action, 'payload.comparePeriod', '');
    },
    setHasDifference: (state, action) => {
      state.hasDifference = action.payload.hasDifference;
    },
    // The flux switch is active, toggled on.
    setFluxAnalysisActive: (state, action) => {
      state.fluxAnalysisActive = action.payload.fluxAnalysisActive;
    },
    // Is the analysis still loading? POST / endpoint
    setFluxAnalysisLoading: (state, action) => {
      state.fluxAnalysisLoading = action.payload.fluxAnalysisLoading;
    },
    // Are the percent and absolute values loading still? GET /changes endpoint
    setFluxChangesLoading: (state, action) => {
      state.fluxChangesLoading = action.payload.fluxChangesLoading;
    },
    reset: () => INITIAL_STATE,
  },
});

// Action creators are generated for each case reducer function
export const {
  reset,
  setAutoApproveReports,
  setFluxAnalysisActive,
  setFluxChangesLoading,
  setFluxAnalysisLoading,
  setCurrentPeriod,
  setComparePeriod,
  setHasDifference,
} = reportsSlice.actions;

export default reportsSlice.reducer;
